import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Playlist } from '@app/library/models/playlist.model';
import { LibraryModalService } from '@app/library/services/library-modal.service';
import {
  PlaylistTracksFailure,
  PlaylistTracksRequest,
  PlaylistTracksSuccess,
} from '@app/library/states/playlist-tracks.actions';
import { PlaylistTracksState } from '@app/library/states/playlist-tracks.state';
import { StartEditPlaylist } from '@app/library/states/playlists.actions';
import { exportSecMin, TimeSplited } from '@app/shared/utils';
import { Store } from '@ngxs/store';
import { UiStoreHelperService } from '@radioking/shared/common-services';
import {
  OpenSpecificPanel,
  PANELS_KEYS,
  TryActionUnlessPanelIsBlocking,
} from '@radioking/shared/pannel-manager';
import { SearchBarComponent } from '@radioking/ui/input';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'rk-playlist-header',
  templateUrl: './playlist-header.component.html',
  styleUrls: ['./playlist-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlaylistHeaderComponent implements OnInit {
  @Input()
  playlist: Playlist;

  @Input()
  displayedTracks: number;

  @Input()
  processing = false;

  @ViewChild('searchBar', { static: true })
  searchBar: SearchBarComponent;

  @Output()
  readonly changeSearch = new EventEmitter();

  tracksTime$: Observable<number>;

  currentSearchValue: string;

  playlistCovers$: Observable<string[]>;

  isLoadingTracks$: Observable<boolean>;

  constructor(
    private readonly store: Store,
    private readonly modalService: LibraryModalService,
    private readonly _uiHelper: UiStoreHelperService,
  ) {}

  ngOnInit() {
    this.tracksTime$ = this.store
      .select(PlaylistTracksState.playlistTracksTime)
      .pipe(map(fn => fn(this.playlist.id)));

    this.playlistCovers$ = this.store
      .select(PlaylistTracksState.playlistCoversPreview)
      .pipe(map(fn => fn(this.playlist.id)));

    this.isLoadingTracks$ = this._uiHelper.getLoadingState(PlaylistTracksRequest, [
      PlaylistTracksSuccess,
      PlaylistTracksFailure,
    ]);
  }

  onSearchInput(e: string) {
    if (typeof e === 'string') {
      this.currentSearchValue = e;
      this.changeSearch.emit(e);
    }
  }

  editPlaylist() {
    this.store.dispatch(
      new TryActionUnlessPanelIsBlocking(
        new OpenSpecificPanel(
          PANELS_KEYS.EDIT_PLAYLIST,
          new StartEditPlaylist(this.playlist),
        ),
      ),
    );
  }

  addTracks() {
    this.store.dispatch(
      new TryActionUnlessPanelIsBlocking(
        new OpenSpecificPanel(PANELS_KEYS.ADD_TO_PLAYLIST),
      ),
    );
  }

  uploadTracks() {
    this.modalService.playlistUploadBox(null, this.playlist);
  }

  clearSearchBar() {
    this.searchBar.value = '';
    this.currentSearchValue = '';
  }

  deletePlaylist() {
    this.modalService.deletePlaylist(this.playlist);
  }

  duplicatePlaylist() {
    this.modalService.duplicatePlaylist(this.playlist);
  }

  getMinutesAndHours(value: number): TimeSplited {
    return exportSecMin(value);
  }

  placeMatMenu() {
    const matMenu: HTMLElement = document.querySelector('.mat-mdc-menu-panel');
    matMenu.style['position'] = 'absolute';
    matMenu.style.left = '42px';
    matMenu.style.top = '-35px';
  }
}
